// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterButtons_container__Q7N2N","inner":"FooterButtons_inner__eiSVW","buttons":"FooterButtons_buttons__Dvbbr"};